import React, { useCallback, FC, ChangeEvent, ComponentProps } from 'react';

import { cn } from 'Modules/ui';

import { usePaginationFilter, PaginationFilterField } from '../../utils';
import styles from './index.module.scss';


type InputProps = Omit<ComponentProps<'input'>, 'value' | 'onChange'>;

export const PaginationInputFilterField: FC<PaginationFilterField & InputProps> = React.memo(({
    path,
    field,
    className,
    ...props
}) => {
    const { value, onChange: onFilterChange } = usePaginationFilter<string>(path, field);
    const currentValue = value || '';
    const onChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => onFilterChange(e.target.value),
        [onFilterChange],
    );

    return (
        <input
            className={cn(styles.input, className)}
            value={currentValue}
            onChange={onChange}
            {...props}
        />
    );
});
